import React from "react";
import { styled } from "@mui/system";
import StateInterface from "../../../redux-magic/state-interface";
import { ObjectId } from "mongodb";
import SummaryPropertyCard from "./SummaryPropertyCard";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import SvgIcon from "@mui/material/SvgIcon";
import BroadcastIcon from "../../../public/images/broadcast/broadcastIcon.svg";

const Container = styled("div")({
  width: "100vw",
  height: "86px",
  top: "663px",
  backgroundSize: "cover",
  flex: 1
});

// Container
const HeaderContainer = styled("div")({
  width: '100vw',
  minHeight: '24rem',
  display: 'block',
  gap: '8px',
  background: "#621B16",
  borderRadius: "0 0 16px 16px",
  color: "#fff",
  flexDirection: "column",
  alignItems: "center",
  // flex: 1
});

const InfoIcon = styled(InfoOutlinedIcon)({
  width: '58px',
  height: '58px',
});

const Title = styled(Typography)({
  fontWeight: '700',
  lineHeight: '133%',
  margin: "0 10px 0 8px",
  width: 'max-content',
});

const Section = styled("div")({
  width: '100vw',
  height: '205px',
  display: "flex",
  flexDirection: "column",
  left: '16px',
  padding: "0 24px 0 24px",
});

const Label = styled("div")({
  fontWeight: '400',
  fontSize: '12px',
  lineHeight: '12px',
  letterSpacing: '0.15px',
});

const Value = styled(Typography)({
  fontWeight: '700',
  letterSpacing: '0.15px',
});

const Notes = styled(Typography)({
  letterSpacing: '0.15px',
});

const ValueSection = styled("div")({
  gap: '2px',
  display: "flex",
  flexDirection: "column",
  padding: "24px 0 0 0",
});

const ValueContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
});

const ButtonContainer = styled("div")({
    width: '100vw',
    justifyContent: 'center',
    display: 'flex',
   position: 'absolute',
    bottom: '24px',
})

const BroadcastButton = styled(Button)({
  width: '326px',
  height: '40px',
  backgroundColor: "#000000",
  borderRadius: '12px',
});

const BroadcastSection = styled("div")({
   display: "flex", 
   width: "100vw",
   alignItems: "center", 
   justifyContent: "space-between", 
   padding: "5px 1px 0 7px",
})

export default function Summary(
  {
    broadcast,
    propertyId,
    business_profile_id,
    userId,
    setPage,
    propertyStatus,
  }: 
  {
    broadcast:  StateInterface["broadcast_data"] | undefined | null;
    propertyId: string | ObjectId;
    business_profile_id: string | ObjectId | undefined | null;
    userId: string | ObjectId;
    setPage: Function;
    propertyStatus: string;
  }
) {

  const handleBroadcast = async() => {
    const reqUrl: string = "/api/broadcast/create-new-broadcast";
    const response = await fetch(reqUrl, {
      cache: "no-store",
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify({
        no_of_agents: broadcast?.no_of_agents || 0,
        creator_user_id: userId,
        creator_business_profile_id: business_profile_id,
        property_id: propertyId,
        commission_offered: broadcast?.commission_offered || 0,
        notes: broadcast?.notes || "",
        property_status: propertyStatus,
      }),
    });

    const data = await response.json();
    if (data.status == "success") {
      setPage('success');
    } else if (data.status == "failure") {
    }
  };

  return (
    <Container>
      <HeaderContainer>
        <BroadcastSection>
          <div>
            <InfoIcon />
            <Title variant="h5">Preview your<br />broadcast details</Title>
          </div>
          <SvgIcon
            component={BroadcastIcon}
            inheritViewBox={false}
            viewBox="0 0 156 155"
            width={149}
            height={157}
            sx={{
              width: 'fit-content',
              height: '117px',
              angle: '168.69 deg',
              marginBottom: '-36px',
            }}
          />
        </BroadcastSection>
        <SummaryPropertyCard PropertyId={propertyId}/>
      </HeaderContainer>
      <Section>
        <ValueSection>
          <Label>Broadcasted to</Label>
          <Value variant="body1">
            Top {broadcast?.no_of_agents || 0} agents
          </Value>
        </ValueSection>
        <ValueSection>
          <ValueContainer>
            <Label>Commission offered</Label>
            <EditOutlinedIcon onClick={()=> setPage('commission')}/>
          </ValueContainer>
          <Value variant="body1">{broadcast?.commission_offered || 0}%</Value>
        </ValueSection>
        <ValueSection>
          <ValueContainer>
            <Label>Additional note</Label>
            <EditOutlinedIcon onClick={()=> setPage('notes')}/>
          </ValueContainer>
            <Notes variant="subtitle1">{broadcast?.notes || 'No notes entered'}</Notes>
        </ValueSection>
      </Section>
      <ButtonContainer>
        <BroadcastButton variant="contained" onClick={handleBroadcast}>Broadcast</BroadcastButton>
      </ButtonContainer>
    </Container>
  );
}
